import React, { memo, useCallback } from 'react'

import { Icon, Search as SearchIcon, TextInput } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, string } from 'prop-types'

import { NOOP } from 'Utils/stableDefaults'

const searchIconSize = { height: '16px', width: '16px' }
const leadIcon = <Icon notSpaced svgComponent={SearchIcon} color="dark" size={searchIconSize} />

function Search({ value = '', onChange = NOOP }) {
  const handleInputChange = useCallback(
    event => onChange(event.target.value),
    [onChange],
  )

  return (
    <TextInput
      id="community-gallery-search"
      isPilot
      size="medium"
      value={value}
      onChange={handleInputChange}
      placeholder="Search"
      leadIcon={leadIcon}
      wrapperClassName="filter-search"
      textInputClassName="filter-search__input"
    />
  )
}

Search.propTypes = {
  value: string,
  onChange: func,
}

export default memo(Search)
